const Menu = [
  { header: "Aprendizado" },
  {
    name: "courses",
    icon: "book",
    title: "Meus Cursos",
    component: "/pages/course/CourseList",
  },
  {
    name: "mocks.search",
    icon: "search",
    title: "Questões",
    component: "/pages/quiz/MockSearch",
  },
  {
    name: "mocks",
    icon: "check",
    title: "Simulados",
    component: "/pages/quiz/MockList",
  },
  {
    name: "mocks.logs",
    icon: "history",
    title: "Histórico",
    component: "/pages/mock/MockLogs",
  },
  {
    name: "exams",
    icon: "assignment",
    title: "Provas",
    component: "/pages/exams",
  },
  // { header: "Evento" },
  // {
  //   name: "event.mocks",
  //   icon: "check",
  //   title: "Simulado CFP® 50",
  //   component: "/pages/event_mock/EventMock",
  // },
  { header: "Acelerar" },
  {
    name: "shop",
    icon: "shop",
    title: "Comprar",
    component: "/pages/shop/Shopping",
  },
  { header: "Ajuda" },
  {
    name: "support",
    icon: "help",
    title: "Suporte",
    component: "/pages/support/Support",
  },
];

// reorder menu
Menu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      const textA = x.title.toUpperCase();
      const textB = y.title.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  }
});

export async function getMenu() {
  try {
    return Menu;
  } catch (e) {
    console.error(e);
    return Menu;
  }
}
export default Menu;
